import React, { useContext, useState } from "react";
import { VotingContext } from "./VotingNavigation";
import { View, Text, StyleSheet, Dimensions } from "react-native";
import _ from "lodash";
import { fonts } from "../../common/styles/fonts";
import PlayStore from "../../components/PlayStore";
import { AppStore } from "../../components/AppStore";
import { MascotBlackCying } from "../../common/icons/mascot_black_crying";

export const NotFoundPage = () => {
  const { meetingError, meeting } = useContext(VotingContext);

  const notFoundText =
    meetingError ||
    (meeting && _.isNumber(meeting.generated_index)
      ? "The voting for this meeting has finished"
      : "Your voting link has expired");

  const [deepLink, setDeepLink] = useState("");

  return (
    <View
      style={{
        height: Dimensions.get("window").height,
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <View style={styles.screen}>
        <MascotBlackCying />
        <Text
          style={{
            marginBottom: 8,
            marginTop: 87,
            ...fonts.largeText_bold,
          }}
        >
          Whoops!
        </Text>
        <Text
          style={{
            textAlign: "center",
            ...fonts.mediumText_regular,
          }}
        >
          {notFoundText} <br /> Download gadder to organise a new meeting.
        </Text>
        <View style={styles.buttonContainer}>
          <PlayStore deepLink={deepLink} />
          <AppStore deepLink={deepLink} />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    alignItems: "center",
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 78,
    height: "100%",
    maxWidth: 500,
    width: "100%",
  },
  buttonContainer: {
    marginTop: 158,
    flexDirection: "row",
    justifyContent: "space-between",
    paddingLeft: 20,
    paddingRight: 20,
    maxWidth: 700,
    width: "100%",
  },
});
